// ** Redux Imports
import { Action } from 'redux'
import { ThunkDispatch } from '@reduxjs/toolkit'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { GygUserDeviceType, GygUserDeviceStateType } from 'src/types/apps/gygUserDeviceType'

// ** Axios Imports
import type { AxiosInstance } from 'axios'
import { GET_USER_DEVICES_BY_USER_ID_ACTION, USER_DEVICE_SLICE_NAME } from './actions'

type AxiosMiddlewareExtras = {
  httpClient: AxiosInstance
}

interface Redux {
  getState: () => any
  dispatch: ThunkDispatch<any, AxiosMiddlewareExtras, Action<string>>
  extra: AxiosMiddlewareExtras
}

interface UserDeviceResponse {
  data: GygUserDeviceType[]
}

export const getUserDeviceByUserId = createAsyncThunk<UserDeviceResponse, string, Redux>(
  GET_USER_DEVICES_BY_USER_ID_ACTION,
  async (userId: string, { extra }) => {
    try {
      const response = await extra.httpClient(`user-devices?user=${userId}`)

      return response.data
    } catch (error) {
      throw new Error(String(error))
    }
  }
)

const initialState: GygUserDeviceStateType = {
  gygUserDevices: [],
  gygUserDevice: null,
  pending: false,
  getDevicePending: false,
  addDevicePending: false,
  updateDevicePending: false,
  deleteDevicePending: false
}

export const gygUserDeviceSlice = createSlice({
  name: USER_DEVICE_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getUserDeviceByUserId.pending, state => {
        state.getDevicePending = true
      })
      .addCase(getUserDeviceByUserId.fulfilled, (state, action) => {
        state.gygUserDevices = action.payload.data
        state.getDevicePending = false
      })
      .addCase(getUserDeviceByUserId.rejected, state => {
        state.getDevicePending = false
      })
  }
})

export default gygUserDeviceSlice.reducer
